import React from "react";
import { ReactComponent as Icon } from "../files/email.svg";
import ISVGIconProps from "../ISVGIconProps";

const EmailIcon = ({
    fill,
    style = {},
    className = "",
}: ISVGIconProps) => {
    return <Icon className={className} fill={fill} style={style} />;
};

export default EmailIcon;
